import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import ClanHeader from './ClanHeader';
import OverallStats from './OverallStats';
import ClanTrophies from './ClanTrophies';
import { Footer } from '../common/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { useDataState } from '../../providers/DataProvider.hooks';
import ClanMemberStats from './ClanMemberStats';
// import TopClanCathletes from './TopClanCathletes';
import CurrentSeasonStats from './CurrentSeasonStats';
import LastTournamentStats from './LastTournamentStats';

function Clan() {
    const { selectedClan, clans, setSelectedClan } = useDataState();
    const { clanName } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!selectedClan && clanName && clans) {
            const existingClan = clans?.data.find((clan) => clan.clan === clanName);
            if (existingClan) {
                setSelectedClan(existingClan);
            } else {
                navigate('/');
            }
        }
    }, [selectedClan, clans, clanName, setSelectedClan, navigate]);

    return (
        <Box>
            <ClanHeader></ClanHeader>
            <OverallStats></OverallStats>
            <ClanTrophies></ClanTrophies>
            <LastTournamentStats></LastTournamentStats>
            <CurrentSeasonStats></CurrentSeasonStats>
            {/* <TopClanCathletes></TopClanCathletes> */}
            <ClanMemberStats></ClanMemberStats>
            <Footer colorBg></Footer>
        </Box>
    );
}

export default Clan;
